import {useCustomerResponse} from '../customer/customer.hooks';

const usePersonalizedBrands = () => {
  const {data} = useCustomerResponse();
  return {
    favorite: data?.brands?.liked ?? [],
    oftenBought: data?.brands?.bought || [],
    recommended: data?.brands?.interestedNotBoughtOrLiked || [],
  };
};

export const useFavoriteBrandStatusById = (brandId?: number) => {
  const brandData = usePersonalizedBrands();
  const biKeys = Object.keys(brandData) as (keyof typeof brandData)[];

  if (!brandId) {
    return null;
  }

  for (const biKey of biKeys) {
    if (brandData[biKey]?.includes(brandId)) {
      return biKey;
    }
  }
  return null;
};

export const useProfileFollowedState = ({idolId}: {idolId?: number}) => {
  const {data} = useCustomerResponse();
  const likedIdols = data?.idols?.liked ?? [];
  const isFollowed = Boolean(idolId && likedIdols.includes(idolId)) ?? false;

  return isFollowed;
};

export const useProfileLikedState = ({outfitId}: {outfitId?: number}) => {
  const {data} = useCustomerResponse();

  const likedOutfits = data?.outfits?.liked ?? [];
  const isLiked = Boolean(outfitId && likedOutfits.includes(outfitId)) ?? false;

  return isLiked;
};
